<app-list-view [service]="ingredientsService" [displayedColumns]="['id', 'name']"></app-list-view>
